import { FormRows } from '@acorns/web-components'
import * as Sentry from '@sentry/browser'
import { object, string } from 'yup'

import { EmailInput } from 'components/EmailInput'
import { sendToSentry } from 'utils/errors'

import userQuery from './gql/user.query.gql'

export type FormValues = {
  email: string
}

export const validationSchema = object().shape({
  email: string()
    .required('Please enter a valid email')
    .email('Please enter a valid email'),
})

export const handleSubmit = (values, { props, ...ownProps }) => {
  props.setSubmitting(true)
  const variables = {
    ...values,
  }

  return props
    .updateEmail({
      variables,
      refetchQueries: [{ query: userQuery }],
    })
    .then(data => {
      const { email } = data.data.updateEmail
      props.setUpdatedEmail(email)
    })
    .then(() => props.setChangeEmail(!props.changeEmail))
    .then(() => props.setSubmitting(false))
    .catch(error => {
      props.setSubmitting(false)
      props.setAlreadyRegisteredEmail(values.email)
      Sentry.addBreadcrumb({
        message: 'User attempted to update their email from the success page.',
      })
      sendToSentry(error)
    })
}

export const mapPropsToValues = ({ data }) => {
  const values = {
    email: !data.loading && data.user ? data.user.email : '',
  }

  return values
}

export default data => {
  const rows: FormRows = [
    [
      {
        name: 'email',
        label: 'Email *',
        type: EmailInput,
        maxLength: 50,
        placeholder: (data.user && data.user.email) || '',
        sizes: { sm: 12, md: 12, xs: 12 },
      },
    ],
  ]
  return rows
}
